<!--
  优惠券弹窗
-->
<template>
  <van-popup
    v-model="popupFlag"
    class="coupon-popup"
    :close-on-click-overlay="false"
    get-container="body"
  >
    <div class="popup-top">
      <img
        class="title"
        :class="{ titleEn: language == 'en' }"
        :src="
          require('@/assets/images/life/popup/title_' +
            (language == 'en' ? 'en' : 'cn') +
            '@2x.png')
        "
      />
    </div>
    <div class="coupon-content">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="left">
          <img :src="httpUrl + item.image" />
        </div>
        <div class="center">
          <h3>{{ item.shop_name }}</h3>
          <span
            class="ticket"
            :class="item.coupon_type == 2 ? 'style2' : 'style1'"
          >
            {{
              item.coupon_type == 2
                ? $t("coupon.voucher")
                : $t("coupon.cashback")
            }}
          </span>
          <p>{{ item.discount_name }}</p>
        </div>
        <div class="right">
          <h4 :class="item.coupon_type == 2 ? 'text-orange' : 'text-red'">
            {{ item.discount }}
          </h4>
          <van-button
            :type="item.coupon_type == 2 ? 'warning' : 'danger'"
            size="mini"
            @click="popupFlag = false"
          >
            {{ $t("coupon.goUse") }}
          </van-button>
        </div>
      </div>
    </div>
    <van-icon @click="popupFlag = false" name="close" />
  </van-popup>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    couponFlag: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {
      popupFlag: false
    };
  },
  created() {
    console.log("couponFlag", this.couponFlag);
    this.popupFlag = this.couponFlag;
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    clickCoupon(shopId) {
      this.$router.push({
        path: "/store",
        name: "store",
        query: { shopId: shopId }
      });
    }
  },
  watch: {
    couponFlag(bol) {
      this.popupFlag = bol;
    },
    popupFlag(bol) {
      this.$emit("update:couponFlag", bol);
    }
  }
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.text-red {
  color: #fc3c46;
}
.coupon-popup {
  width: 326px;
  background-color: transparent;
  text-align: center;
  .popup-top {
    height: 115px;
    background-image: url("@{images}life/popup/top@2x.png");
    background-size: 100%;
    .title {
      margin-top: 40px;
      width: 180px;
      &.titleEn {
        margin-top: 20px;
        width: 225px;
      }
    }
  }
  .coupon-content {
    padding-bottom: 8px;
    background: #fc3c46;
    border-radius: 0 0 5px 5px;
    max-height: 282px;
    overflow-y: auto;
    .item {
      padding: 0 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 326px;
      height: 94px;
      line-height: 1;
      background-image: url("@{images}life/popup/list_bg@2x.png");
      background-position: center;
      background-size: cover;
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        border-radius: 4px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .center {
        flex: 1;
        margin: 0 10px;
        text-align: left;
        h3 {
          font-size: 14px;
          line-height: 1;
          font-weight: 400;
        }
        .ticket {
          margin: 5px 0;
          display: inline-block;
          padding: 2px 5px;
          line-height: 1.2;
          color: #fc3c46;
          border: 1.1px solid #fc3c46;
          border-radius: 3px;
          &.style2 {
            color: #fe7800;
            border: 1.1px solid #fe7800;
          }
        }
      }
      .right {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h4 {
          margin-bottom: 5px;
          font-size: 16px;
        }
        button {
          padding: 0 5px;
        }
      }
    }
  }
  .van-icon-close {
    margin-top: 10px;
    color: #fff;
    font-size: 36px;
  }
}
</style>
